module.exports = __webpack_public_path__ + "static/img/icon tj wj01.f79b78b9.svg";